import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';

// Rxjs
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/exhaustMap';
import 'rxjs/add/operator/switchMap';
import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs/Observable';

// Services
import { ParticipantStatementSearch } from '../services/participant-statement-search.service';

// Actions
import * as UIActions from '../actions/ui.actions';
import * as SearchActions from '../actions/search.actions';

@Injectable()
export class SearchEffects {

  // Constructor
  constructor(
    private actions$: Actions,
    private participantStatementSearch: ParticipantStatementSearch
  ) {}

  // ======= SEARCH FOR PARTICIPANT / STATEMENTS ========
  // ====================================================
  @Effect()
  searchForParticipantStatement$ = this.actions$
    .ofType(SearchActions.SEARCH_FOR_PARTICIPANT_STATEMENT)
    .map((action: SearchActions.SearchForParticipantStatement) => action.payload)
    .switchMap(query =>
      this.participantStatementSearch
        .searchForParticipantStatement(query)
        .map((response: any) => new SearchActions.SearchForParticipantStatementSuccess(response.data[0]))
        .catch(() => of())
    );

  // Auto Save
  @Effect()
  autoSaved$ = this.actions$
    .ofType(UIActions.AUTO_SAVED)
    .exhaustMap(() => {
      return Observable.timer(3000).map(() => new UIActions.ClearAutosave());
    });

}



// WEBPACK FOOTER //
// ./src/app/core/effects/search.effects.ts